import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';
import initPolyfills from './polyfills';

initPolyfills();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
